module.exports = __webpack_public_path__ + "static/media/icon_chevron_left.85bc6bfe.svg";